module.exports = __webpack_public_path__ + "static/media/jest.2c3c135c.svg";